import React, {Component} from 'react';
import './menu.css'
class Menu extends Component {
    render() {
        return (
            <div className="menu">
                <div className="submenu">
                    <span>1.  Hotel</span>
                    <span>2. Lobby</span>
                    <span>3. Restaurant bistronomique</span>
                </div>
                <div className="submenu">
                    <span>4. Centre séminaire</span>
                    <span>5. Wellness</span>
                    <span>6. Vue lac inférieur</span>
                </div>
                <div className="submenu">
                    <span>7. Aqua Park</span>
                    <span>8. Natura Park</span>
                    <span>9. Tyrolienne sur lac</span>
                </div>
                <div className="submenu">
                    <span>10. Fun Park</span>
                    <span>11. Cable Park</span>
                    <span>12. Vita Park</span>
                </div>
            </div>
        );
    }
}

export default Menu;